import { useCreateRuleToast } from '@/components/cashflow/useCreateRuleToast';
import { useToasts } from '@/components/common/Toasts';
import { useMutation } from '@apollo/client';
import { UpdateTransactionEntryTagsDocument } from '@common/graphql/generated';
import { CashflowTransactionEntry } from '@common/react/cashflow';
import { TOASTS } from '@common/toasts';

export const useUpdateTags = (transactionEntry: CashflowTransactionEntry) => {
    const showCreateRuleToast = useCreateRuleToast();
    const { showErrorToast } = useToasts();

    const [updateTags] = useMutation(UpdateTransactionEntryTagsDocument, {
        onCompleted: (data) => {
            if (data.updateTransactionEntryTags?.transactionEntry) {
                showCreateRuleToast({
                    before: transactionEntry,
                    after: data.updateTransactionEntryTags.transactionEntry,
                    field: 'tagNames',
                });
            }
        },
        onError: () => {
            showErrorToast(TOASTS.updateTransactionEntryError);
        },
    });

    return updateTags;
};
